// extracted by mini-css-extract-plugin
export default {"content":"KG","wrapper":"LG","gif":"MG","textContent":"NG","gifContainer":"OG","proteinGif":"PG","counter_img":"QG","usage-container":"RG","usage-list":"SG","checklist":"TG","counter_title":"UG","counter_wrapper":"VG","active":"WG","usage-counter":"XG","line":"YG"};
    if(module.hot) {
      // 1713361651665
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  